import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Table } from "@pentabd/ui";

import { HrmEmployeeFilter, SearchBox } from "@components";
import { TableColumn } from "./TableColumn";

import { useSeniors } from "@hooks/HRM/employees/useSeniors";

import { TablePagination } from "@helpers/tablePagination";

export const DossierListTable = () => {
  const { t } = useTranslation();

  const { employees, pagination, employeeRequest, handleQuery } = useSeniors();
  const { total } = pagination || {};

  const { control, register, setValue } = useForm();

  return (
    <div>
      <HrmEmployeeFilter
        handleQuery={handleQuery}
        control={control}
        register={register}
        setValue={setValue}
        withoutDates
      />
      <div className="mt-10">
        <Table
          loading={employeeRequest}
          header={{
            title: t("SENIORITY_LIST.TABLE_HEADER.LABEL"),
            badge: {
              label: `${total || 0}`,
              size: "sm",
              type: "primary",
            },
            buttons: [
              <SearchBox
                key="search"
                control={control}
                handleQuery={handleQuery}
              />,
            ],
          }}
          columns={TableColumn(t) as any}
          rows={employees}
          pagination={TablePagination(pagination, handleQuery)}
        />
      </div>
    </div>
  );
};
